import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'app/environments/environment';
import { CookingType, CreateCookingType, UpdateCookingType, ToggleStatusResponse } from 'app/models/cookings/model';



@Injectable({ providedIn: 'root' })
export class CookingTypeService {
  private readonly http = inject(HttpClient);
  //private readonly baseUrl = `${environment.api}/v2/CookingType`;

  private get baseUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2/CookingType";
  }

  // GET: api/cookingtype?activeOnly=true
  getAll(activeOnly?: boolean): Observable<CookingType[]> {
    let params = new HttpParams();
    if (activeOnly !== undefined) params = params.set('activeOnly', activeOnly);

    return this.http.get<CookingType[]>(this.baseUrl, { params });
  }

  // GET: api/cookingtype/5
  getById(id: number): Observable<CookingType> {
    return this.http.get<CookingType>(`${this.baseUrl}/${id}`);
  }

  // POST: api/cookingtype
  create(dto: CreateCookingType): Observable<CookingType> {
    return this.http.post<CookingType>(this.baseUrl, dto);
  }

  // PUT: api/cookingtype/5
  update(id: number, dto: UpdateCookingType): Observable<CookingType> {
    return this.http.put<CookingType>(`${this.baseUrl}/${id}`, dto);
  }

  // DELETE: api/cookingtype/5
  delete(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.baseUrl}/${id}`);
  }

  // PATCH: api/cookingtype/5/toggle-status
  toggleStatus(id: number): Observable<ToggleStatusResponse> {
    return this.http.patch<ToggleStatusResponse>(
      `${this.baseUrl}/${id}/toggle-status`,
      {}
    );
  }
}